export function checkFileSize(size) {
    const SIZE_LIMIT = 30;
    return size / 1024 / 1024 > SIZE_LIMIT ? `檔案超過${SIZE_LIMIT}MB，請重新選擇檔案。` : null;
}

export function checkFilePictureType(type) {
    const ALLOW_LIST = ['image/jpeg', 'image/png'];
    return ALLOW_LIST.includes(type) ? null : '檔案類型不正確，請重新選擇';
}
